import { ExportIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import type { ActionMenuItem } from '@/components';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import type { ReportEvent } from '@/types/report';
import { exportableReportEvent } from '@/utils/export';

interface ReportEventExportControls {
    busy: boolean;
    startExport: (event: ReportEvent) => void;
}

export function useExportReportEventMenuItem() {
    const { t } = useTranslation(I18nNamespace.EVENTS);

    return (
        event: ReportEvent,
        exportControls: ReportEventExportControls,
    ): ActionMenuItem[] => {
        if (!exportableReportEvent(event)) {
            return [];
        }
        return [
            {
                key: 'export',
                label: t('actions.export'),
                icon: ExportIcon,
                disabled: exportControls.busy,
                onSelect: () => exportControls.startExport(event),
            },
        ];
    };
}
